/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const { className } = props;

	const wrapperClasses = classnames(
		className,
		'gutenify-block-slide-item-wrapper',
		'swiper-slide'
	);

	return (
		<div className={ wrapperClasses }>
			<InnerBlocks.Content />
		</div>

	);
}

